import { useMemo } from 'react';

import { useBreakpointValue } from '@bonusly/design-system';

export const useResponsiveTabs = <T>(tabs: T[]) => {
	const tabCount = useBreakpointValue({ base: Infinity, xs: 5 }) || Infinity;

	return useMemo(() => {
		const { head, tail } = (() => {
			if (tabs.length <= tabCount) {
				return {
					head: tabs,
					tail: [],
				};
			}

			return {
				head: tabs.slice(0, tabCount - 1),
				tail: tabs.slice(tabCount - 1),
			};
		})();

		const percent = tabCount === Infinity ? '20%' : Math.trunc((1 / (tabCount || 1)) * 100);
		const tabSize = `${percent}%`;

		return {
			displayedTabs: head,
			overflowTabs: tail,
			tabSize,
		};
	}, [tabs, tabCount]);
};
